<template>
  <div class="rating-message card border-0 p-5">
    <p>
      {{ message }}
    </p>
    <div class="d-flex mt-3 align-items-start justify-content-between">
      <div class="d-flex flex-column">
        <span class="small pb-0">{{ name }}</span>
        <small class="text-secondary">{{ formatedDate }}</small>
      </div>

      <rating-view :rating="5" isSmall />
    </div>
  </div>
</template>
<script>
import RatingView from "@/components/marketplace/RatingView";
import moment from "moment";

export default {
  components: {
    RatingView
  },
  props: {
    message: {
      type: String,
      default: () => ""
    },
    name: {
      type: String,
      default: () => ""
    },
    date: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    formatedDate() {
      return moment(this.date, "YYYY-MM-DD").format("DD MMM YYYY");
    }
  }
};
</script>
<style lang="scss" scoped>
.rating-message {
  min-height: 172px;
  max-width: 100%;
}
</style>
